import { P2GAlert, P2GBox, P2GButton, P2GText, SvgWarningTriangle } from '@parcel2go/core-ui';
import { SidePanelContent } from '~/components/sidepanel-section';

const ShopCollectionWarning = ({ accept }: { accept: () => void; names: string[] }) => {
  return (
    <P2GAlert type="info" icon={<SvgWarningTriangle />} data-testid="shop-collection-warning">
      <SidePanelContent>
        <P2GText>
          You’ve selected one or more services that require your customers to collect their parcel from a{' '}
          <strong>shop</strong> or <strong>locker</strong>.
        </P2GText>
        <P2GText>Please ensure your customers are aware of this before proceeding.</P2GText>
        <P2GText>
          If necessary, check with your chosen marketplace/eCommerce platform to confirm whether you need to update your
          listing to inform your customers.
        </P2GText>
        <P2GBox mt={2}>
          <P2GButton variant="primary" onClick={accept}>
            Accept and Continue
          </P2GButton>
        </P2GBox>
      </SidePanelContent>
    </P2GAlert>
  );
};
export default ShopCollectionWarning;
